(function (app) {

    app.provider("carrierApi",
        [
            function () {
                this.$get = [
                    "complianceHubApiGateway", function (complianceHubApiGateway) {
                        var service = {};

                        service.getCarrier = function (carrierId) {
                            return complianceHubApiGateway.get("/Carriers/" + carrierId)   
                        };

                        service.getCarriers = function () {
                            return complianceHubApiGateway.getArray("/Carriers");
                        };

                        return service;
                    }
                ];
            }
        ]);
})(window.app);